"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterLayoutGroupState = void 0;
var SfilterKey_1 = require("@/pages/common/states/sfilter/SfilterKey");
exports.defaultSfilterLayoutGroupState = {
    key: SfilterKey_1.SfilterKey.LAYOUT,
    name: 'Property Type',
    opened: false,
    options: [
        { name: 'Apartment', selected: false, key: 'apartment', id: 1 },
        { name: 'Duplex', selected: false, key: 'duplex', id: 2 },
        { name: 'Triplex', selected: false, key: 'triplex', id: 3 },
        { name: 'Penthouse', selected: false, key: 'penthouse', id: 4 },
        { name: 'House', selected: false, key: 'house', id: 5 },
        { name: 'Studio', selected: false, key: 'studio', id: 7 },
        { name: 'Village House', selected: false, key: 'village-house', id: 17 },
    ],
};
